import useFetch from './fetch';

export default function useGetTranslationValues() {
  const fetch = useFetch();
  return (keyId) => { return fetch(`/api/value/${keyId}`).then(x => x.json()) };
};
